import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { loadGuidesByCategory } from '../../utils/cmsContentLoader';
import { getGuidePublicPath } from '../../data/guideCategoryMeta';
import DiscoverySection from '../explore/DiscoverySection';
import { Loading } from '../shared';

/** Lists published CMS guides for one category on a hub page. */
function CategoryGuidesSection({
	category,
	title = 'Related guides',
	intro,
	eyebrow = 'Knowledge guides',
	alt = false,
}) {
	const [guides, setGuides] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		setLoading(true);
		loadGuidesByCategory(category)
			.then(setGuides)
			.finally(() => setLoading(false));
	}, [category]);

	if (loading) return <Loading />;
	if (!guides.length) return null;

	return (
		<DiscoverySection eyebrow={eyebrow} title={title} intro={intro} alt={alt}>
			<div className="guide-grid">
				{guides.map((g) => (
					<Link key={g.slug} to={getGuidePublicPath(g.slug)} className="guide-card">
						<h3 className="guide-card__title">{g.title}</h3>
						{g.summary && <p className="guide-card__summary">{g.summary}</p>}
					</Link>
				))}
			</div>
			<p className="mt-3 mb-0">
				<Link to="/guides" className="font-weight-bold">Browse all travel guides →</Link>
			</p>
		</DiscoverySection>
	);
}

export default CategoryGuidesSection;
